import cx from 'classnames';
import {InfoIcon} from '../svg/InfoIcon';

export const InputWrapper = ({
  type,
  'data-qa-id': qaId,
  live = false,
  pristine = false,
  popOverComponent,
  tooltipContent,
  tooltipComponent,
  children,
  label,
  required,
  className,
  id,
  showOptionalLabel,
  overlayClassName,
  startAdornment,
  endAdornment,
  value,
  error,
  success,
  translucent,
}) => {
  const Tooltip = tooltipComponent; // Change the name so jsx can render it.
  return (
    <div className={cx('input-wrapper', className)} id={id ? `${id}__wrapper` : ''}>
      {label && (
        <label className="label2 small input-label" htmlFor={id}>
          {label}
          {required && <span className="label3">*</span>}
          {showOptionalLabel && <span className="label3">(Optional) </span>}
          {popOverComponent ?? null}
          {tooltipContent && Tooltip && (
            <Tooltip
              placement="top"
              trigger={['hover', 'click']}
              overlay={<span>{tooltipContent}</span>}
              overlayClassName={overlayClassName}
              getTooltipContainer={(node) => node}
            >
              <span style={{position: 'relative'}}>
                <InfoIcon className="event-details__info" />
              </span>
            </Tooltip>
          )}
        </label>
      )}
      <div
        className={cx('input-box', {
          select: type === 'time',
          textarea: type === 'textarea',
          otp: type === 'otp',
          'toggle-input-box': type === 'toggle',
          translucent: translucent,
          live,
          empty: pristine ?? !value,
        })}
      >
        {startAdornment && <div className="input__start-adornment">{startAdornment}</div>}
        {children}
        {endAdornment && <div className="input__end-adornment">{endAdornment}</div>}
      </div>
      {error && typeof error === 'string' && (
        <span
          className="input-error"
          data-qa-id={`${qaId || 'input-error'}_inputErrorMessage`}
          role="region"
          aria-live="polite"
          aria-relevant="additions"
        >
          {error}
        </span>
      )}
      {success && typeof success === 'string' && (
        <span
          className="input-success"
          data-qa-id={`${qaId || 'input-success'}_inputSuccessMessage`}
          role="region"
          aria-live="polite"
          aria-relevant="additions"
        >
          {success}
        </span>
      )}
    </div>
  );
};
